import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';

import appLogo from '../../../connect-logo.png'

class AuthCard extends React.Component {

    render() {
        const { children, title, subheader, loading, classes, helpText, actions, helpTextClass } = this.props;
        return (
            <Card classes={{ root: classes.cardElement }} elevation={0}>
                <CardHeader classes={{ root: classes.cardHeader }} disableTypography avatar={
                    <img src={appLogo} alt="" className={ loading? classes.loadingAvatar : classes.logoAvatar} />
                } title={<Typography variant="title">{title}</Typography>} subheader={subheader}></CardHeader>

                <CardContent >
                    {children}
                </CardContent>
                {
                    actions && <CardActions className={classes.signInActions}>
                        {actions}
                    </CardActions>
                }

                {
                    helpText && <CardContent >
                        <Typography className={helpTextClass ? classes[helpTextClass] : classes.info} align="justify">{helpText} </Typography>
                    </CardContent>
                }
            </Card>
        )
    }
}
export default AuthCard;


// WEBPACK FOOTER //
// ./src/Components/Authentication/AuthParts/AuthCard.js